import { Trans, useLingui } from '@lingui/react';
import { NumberFormat } from '@startuptools/ui/NumberFormat';
import { GqlCurrency } from '../../../graphql/base-types.graphql';

const DECIMALS = 6;

interface SccsTableRowFooterProps {
  totalPaid: { [k in GqlCurrency]?: number };
  preCells?: number;
  postCells?: number;
}

export const SccsTableRowFooter = ({ totalPaid, preCells = 3, postCells = 1 }: SccsTableRowFooterProps) => {
  const { i18n } = useLingui();

  return (
    <tfoot>
      {Object.entries(totalPaid).map(([currency, tot]) => (
        <tr key={currency}>
          <th>
            <Trans id="Total" />
          </th>
          <th colSpan={preCells} />
          <th align="right">
            <NumberFormat
              variant="currency"
              locale={i18n.locale}
              currency={currency}
              minimumFractionDigits={DECIMALS}
              maximumFractionDigits={DECIMALS}
            >
              {tot}
            </NumberFormat>
          </th>
          <th colSpan={postCells} />
        </tr>
      ))}
    </tfoot>
  );
};
